<template>
  <div class="page">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'Page',
}
</script>
<style lang="scss" scoped>
.page {
  padding: 12px;
  box-sizing: border-box;
  width: 100%;
  min-height: calc(100vh - 84px);
  background: #f5f5f5;
  ::v-deep {
    .page-title {
      font-size: 24px;
      font-weight: bold;
      color: #333;
      margin-bottom: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      display: none;
    }

    .danger-button {
      color: #f56c6c;
    }

    .danger-button:active {
      color: #f78989;
    }

    .warning-button {
      color: #e6a23c;
    }

    .warning-button:active {
      color: #ebb543;
    }

    .success-button {
      color: #67c23a;
    }

    .success-button:active {
      color: #85ce61;
    }

    .info-button {
      color: #909399;
    }

    .info-button:active {
      color: #a6a9ad;
    }

    .page-content {
      background: #fff;
      margin-bottom: 0;
      padding: 20px;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);

      .el-table-column--selection .cell {
        padding-left: 10px;
        padding-right: 10px;
      }

      .page-content {
        box-shadow: none;
        margin-bottom: 0px;
      }

      > .actions {
        margin-bottom: 10px;
      }
      > .title {
        font-size: 16px;
        margin-bottom: 15px;
      }
      .flex {
        display: flex;
        flex-direction: row;
        // align-items: flex-start;
        justify-content: space-between;
        .right {
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          align-content: center;
          flex-wrap: wrap;
        }
      }
    }

    .page-search {
      label {
        font-weight: 400;
      }

      .el-form--label-top {
        .el-form-item {
          margin-bottom: 10px;
        }
        .el-form-item__label {
          padding-bottom: 0;
          font-size: 12px;
          line-height: 20px;
          margin-bottom: 4px;
        }
        .actions {
          margin-top: 10px;
        }
      }

      .el-form--label-right,
      .el-form--label-left {
        .el-form-item {
          display: flex;
          justify-items: center;
        }

        .el-form-item__label {
          flex: none;
          padding-right: 8px;
        }

        .el-form-item__content {
          flex: auto;
          min-width: 0;
        }
      }

      .el-row {
        margin-bottom: -10px;
      }

      .el-form-item {
        max-width: 100%;
      }

      .el-col {
        .el-form-item {
          width: 100%;
        }
      }

      .el-form-item__content {
        max-width: 100%;
      }

      .el-date-editor {
        max-width: 100%;
      }

      .el-select {
        width: 100%;
      }

      .el-form-item__label {
        &::before {
          content: '';
          display: inline-block;
          width: 0px;
          line-height: 20px;
        }
      }
    }

    .page-tabs {
      .page-tab {
        padding: 6px 0;
      }
      .page-content {
        box-shadow: none;
        margin-bottom: 0px;
      }
    }

    .page-tab {
      .page-content {
        padding: 12px 0;
      }
      .page-search {
        // padding: 0px;
      }
    }

    .center-dialog {
      .el-dialog {
        margin-top: 5vh !important;
        .el-dialog__body {
          // 这里的 120px 是 el-dialog 的头部和底部高度之和
          max-height: calc(90vh - 120px);
          // min-height: calc(50vh - 120px);
          overflow-y: auto;
        }
      }
    }

    .page-dialog {
      .el-dialog {
        .el-dialog__body {
          padding: 12px 20px;

          max-height: calc(90vh - 120px);
          overflow-y: auto;
        }
      }
      .page-content {
        box-shadow: none;
        margin-bottom: 0px;
      }

      .el-form--label-top {
        .el-form-item {
          margin-bottom: 14px;
        }
        .el-form-item__label {
          padding-bottom: 0;
          font-size: 12px;
          line-height: 20px;
          margin-bottom: 0px;
        }
        .actions {
          margin-top: 10px;
        }
      }
    }

    .center-dialog-no-footer {
      .el-dialog {
        margin-top: 5vh !important;
        .el-dialog__body {
          // 这里的 120px 是 el-dialog 的头部和底部高度之和
          max-height: calc(90vh - 54px);
          // min-height: calc(50vh - 54px);
          overflow-y: auto;
        }
      }
    }

    .page-input-info {
      width: 100%;
      background-color: #fff;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      height: 40px;
      line-height: 40px;
      outline: 0;
      padding: 0 15px;
      &[disabled] {
        background-color: #f5f7fa;
        color: #999999;
        cursor: not-allowed;
      }
    }

    .el-form-item__content:has(.page-input-info) {
      line-height: 0;
    }

    .el-form-item--small {
      .page-input-info {
        height: 32px;
        line-height: 32px;
      }
    }

    .el-form {
      .el-row {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 0px;
        &:last-child {
          margin-bottom: -18px;
        }
      }
    }

    .el-table {
      .el-link {
        margin-right: 10px;
        &:last-child {
          margin-right: 0px;
        }
      }
    }
  }
}
</style>
